import { ReactNode, useRef, useState } from "react";
import { Toaster } from "react-hot-toast";
import ModalContext from "./ModalContext";

export default function ModalProvider({ children }: { children: ReactNode }) {
  const dialogRef = useRef<HTMLDialogElement>(null);
  const [content, setContent] = useState<ReactNode>(null);

  return (
    <ModalContext.Provider value={{ setContent, dialogRef }}>
      {children}
      <dialog
        ref={dialogRef}
        className="m-auto backdrop:bg-black/85 rounded-lg border-0 p-0 shadow-2xl"
      >
        {content}
        <Toaster position="top-center" />
      </dialog>
    </ModalContext.Provider>
  );
}
